/**
 * @file Checks whether an organization has personal access tokens enabled.
 */

import { getConfig } from "@components/Config";

/**
 * Checks whether the given organization id is on the personal access tokens allowlist.
 */
const isPersonalAccessTokensEnabled = (organizationId?: string): boolean => {
  const enabledOrgIds = getConfig("PERSONAL_ACCESS_TOKENS_ENABLED_ORG_IDS") as string[];
  const hasOrganizationId = Boolean(organizationId);

  if (!hasOrganizationId) {
    return false;
  }

  return enabledOrgIds.includes(organizationId);
};

export default isPersonalAccessTokensEnabled;
